// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"6d56183a","732":"4215be2f","977":"02420ce8"}[chunkId] + ".chunk.js";
};